import React, { useState, useEffect } from 'react';
import { useOutletContext } from 'react-router-dom'
import axios from 'axios';
import { Cookies } from '../../../../index.js';
import { ClipLoader, PulseLoader } from 'react-spinners';
import { alert_error, alert_success } from "../../../../AppContext.js";
import { useParams, useNavigate, Link } from 'react-router-dom';

const Description = () => {
    const [users, set_users] = useState('');
    const laythongtin = (apikey) => {
        axios
            .post('https://hust.media/api/orders/account/sellers/api/check.php', {
                apikey: apikey
            })
            .then(response => testFunction(response))
            .catch(error => console.log(123 + error));
    };
    useEffect(() => {
        const apiKey = Cookies.get('apikey');
        laythongtin(apiKey);
    }, []);
    const navigate = useNavigate();
    function switch_router(link) {
        navigate(link);
    };
    function testFunction(response) {
        const info = response.data;
        const status = info.status;
        const message = info.message;
        if (status == 0) {
            alert_error(message);
        }
        else if (status == 1) {
            alert_success(message);
            set_users(info.data_api);
        }
        else {
            alert_error('đã xảy ra lỗi vui lòng liên hệ admin')
        }
        if (info.redirect != null && info.redirect != '') {
            setTimeout(function () {
                // Chuyển hướng sang trang web khác
                switch_router(info.redirect);
            }, 1700);
        }
    };
    return (
        <>
            {!users &&
                (<>
                    <div style={{ textAlign: "center" }} className="mt-4 justify-center items-center">
                        <ClipLoader color="#fff" size={150} />
                    </div>
                </>)}
            {users &&
                (
                    <>
                        <div className='px-1 py-3 bg-slate-100 mt-2'>
                            <h5>Thông tin api</h5>
                            {users.accounts_api_url && (
                                <div className='flex items-center gap-2 text-base lg:text-lg'>
                                    <svg
                                        xmlns='http://www.w3.org/2000/svg'
                                        fill='none'
                                        viewBox='0 0 24 24'
                                        strokeWidth={1.5}
                                        stroke='currentColor'
                                        className='w-4 h-4'>
                                        <path
                                            strokeLinecap='round'
                                            strokeLinejoin='round'
                                            d='M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z'
                                        />
                                    </svg>

                                    <span className='min-w-[110px] lg:min-w-[200px]'>Api url</span>
                                    <span>{users.accounts_api_url}</span>
                                </div>
                            )}
                            {users.shop_insurance && (

                                <div className='flex items-center gap-2 text-base lg:text-lg'>
                                    <svg
                                        xmlns='http://www.w3.org/2000/svg'
                                        fill='none'
                                        viewBox='0 0 24 24'
                                        strokeWidth={1.5}
                                        stroke='currentColor'
                                        className='w-4 h-4'>
                                        <path
                                            strokeLinecap='round'
                                            strokeLinejoin='round'
                                            d='M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285z'
                                        />
                                    </svg>
                                    <span className='min-w-[110px] lg:min-w-[200px]'>Bảo hiểm</span>

                                    <span>{users.shop_insurance}</span>
                                </div>
                            )}
                        </div>
                    </>
                )

            }
        </>


    )
}

export default Description
